import request from "@/utils/request";
import Utils from "@/utils";
export default {
  async login(account, password, companyName = "深圳市正能量网络技术有限公司") {
    return request.post("/Security/SignIn", {
      CompanyName: companyName,
      Account: account,
      Password: password,
      AppSource: 4
    });
  },
  // 账号用户信息
  async info(id) {
    return request.post("/ChatUser/GetUserInfo", {
      UserId: id
    });
  },
  async companyInfo(id) {
    return request.post("/ChatUser/GetCompanyInfo", {
      CompanyId: id
    });
  },
  async companyDetail(id, name) {
    return request.post("/Supplier/GetBusinessCard", {
      CompanyName: name,
      CompanyId: id
    });
  },
  // 能量豆流水列表
  async beansList(
    { pageIndex, pageSize, date } = {
      pageIndex: 1,
      pageSize: 10,
      date: Utils.getNowMonth()
    }
  ) {
    return request.post("/EnergyBeans/GetBeansPage", {
      PageIndex: pageIndex,
      PageSize: pageSize,
      Date: date
    });
  },
  // 余额流水列表
  async balanceList(
    { pageIndex, pageSize, date } = {
      pageIndex: 1,
      pageSize: 10,
      date: Utils.getNowMonth()
    }
  ) {
    return request.post("/Money/MyMoneyFlow", {
      PageIndex: pageIndex,
      PageSize: pageSize,
      Date: date
    });
  },
  // 聊天用户信息
  async getChatInfo() {
    return request.post("/ChatUser/MyInfo");
  },
  // 更新聊天用户信息
  async updateChatInfo(params) {
    return request.post("/ChatUser/UpdateSettings", params);
  },
  // 获取微信头像信息，用于提现
  async getWeChatInfo() {
    return request.post("/ChatUser/MyDetail");
  },
  // 更新性别和用户名
  async updateInfo({ nickName, sex }) {
    return request.post("/ChatUser/UpdateInfo", {
      NickName: nickName,
      Sex: sex
    });
  }
};
